import type { RequiredGeneric } from '@pba/react-utils';
import { useTranslation } from 'react-i18next';
import { Form, FormSection, Icon } from 'ui';
import { InvitationLimitAlert } from '../invitation-limit-alert';
import { useReminderInvitationCount } from './hooks';
import { ReminderInvitationsFormItem } from './reminder-invitations-form-item';
import type { InvitationSearchOption } from './types';

export type ExtendedReminderInvitationsFormValues = {
  invitations?: InvitationSearchOption[];
};

type P = {
  alreadyInvitedCount?: number;
  isRequired?: boolean;
};

const ReminderInvitationsFormContent = <T extends ExtendedReminderInvitationsFormValues = never>({
  alreadyInvitedCount = 0,
  isRequired = false,
}: RequiredGeneric<T, P>) => {
  const { t } = useTranslation();
  const invitations = Form.useWatch<InvitationSearchOption[] | undefined>('invitations') ?? [];
  const { invitationCount, invitationLimit } = useReminderInvitationCount({ alreadyInvitedCount, invitations });

  return (
    <FormSection
      title={{
        children: t('People ({{invited}}/{{limit}})', {
          invited: invitationCount,
          limit: invitationLimit,
        }),
        icon: <Icon icon="group-line" />,
      }}
    >
      <ReminderInvitationsFormItem<ExtendedReminderInvitationsFormValues>
        alreadyInvitedCount={alreadyInvitedCount}
        isRequired={isRequired}
      />
      {invitationCount >= invitationLimit ? <InvitationLimitAlert count={invitationLimit} /> : null}
    </FormSection>
  );
};

export default ReminderInvitationsFormContent;
